module.exports = __webpack_public_path__ + "img/pic_location_ChiayiCity.d81d1bd6.png";